<template>
    <div v-bind:class="applied_calendar_css" class="notranslate" tabindex="0">
        <div class="main-container">
            <div class="text-container">
                <div v-if="title" v-bind:class="[titleClass]" v-on:click="clickTitle">
                    {{ title }}
                </div>
                <input v-if="!(mode == 'static')" type="text" v-bind:name="text_input_name" ref="el_text" 
                    v-bind:value="selectedDateString" v-on:input="onTextChanged($event)"
                    v-bind:class="[inputClass, errorClass]" v-on:keyup.up="move('up')" v-on:keyup.down="move('down')"
                    v-on:keyup.enter="onEnter($event)" v-on:keydown.enter="$event.preventDefault()"
                    v-on:blur="onFocusout($event)" v-on:click="onFocus()" v-bind:disabled="disabled ? '' : null"
                    autocomplete="one-time-code" />
            </div>
            <div v-if="value && clear_button" v-bind:class="[closeBtnClass]" v-on:click="clearText">
                <div class="button-clear-icon">
                    &#x2715;
                </div>
            </div>
        </div>
        <div class="list-container" v-bind:class="{ 'hidden': calendar_visible }">
            <div class="calendar-content" v-on:mousedown="$event.preventDefault()">
                <table class="calendar-table" style="background-color:#fff">
                    <thead>
                        <tr>
                            <th class="month-cell" colspan="5">{{ current_month.substring(0, 4) }} {{ new
                                Date(current_month).toLocaleString(locale, { month: "long", timeZone: 'UTC' }) }}</th>
                            <th class="nav-cell" v-on:mousedown="navMonth($event, -1)">&lt;</th>
                            <th class="nav-cell" v-on:mousedown="navMonth($event, 1)">&gt;</th>
                        </tr>
                        <tr>
                            <th class="week-cell" v-for="(weekday, index) in weekdays" v-bind:key="index">
                                {{ weekday }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="days.length > 0">
                        <tr v-for="(row, rowIndex) in 6" v-bind:key="rowIndex">
                            <td v-for="(day, index) in days.slice(rowIndex * 7, (rowIndex + 1) * 7)" v-bind:key="index"
                                v-on:mousedown="selectDay(day)" class="date-cell" v-bind:class="day.css_class_list">
                                <p class="date-cell-header">{{ new Date(day.date).getUTCDate() }}</p>
                                <div class="date-cell-body">
                                    <slot name="date_cell" v-bind:visible-data="day.date"></slot>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ul class="n2-valid" v-bind:class="{ 'n2-errors': errors }">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
    </div>
</template>
<script>

export default {
    name: 'app-calendar',
    props: ['title', 'clear_button', 'time_zone', 'locale', 'label', 'text_input_name', 'value', 'valid_dates', 'selected_dates', 'calendar_css', 'dates_css', 'sunday_css', 'saturday_css', 'min_date', 'max_date', 'disabled', 'css_class', 'errors', 'before_date_show', 'mode', 'initial_month'],
    data: function () {
        return {
            view_month: null,
            userText: '',
            hiddenList: true,
            inputClass: this.input_css_class ? this.input_css_class : (this.title ? 'n2-calendar-input-alt' : 'n2-calendar-input'),
            titleClass: this.title_css_class ? this.title_css_class : 'n2-calendar-title',
            closeBtnClass: this.title ? 'n2-calendar-button-clear-alt' : 'n2-calendar-button-clear'
        };
    },
    mounted: function () {
        this.userText = this.selectedDateString;
    },
    computed: {
        applied_calendar_css: function () {
            return this.calendar_css ? this.calendar_css : 'n2-calendar';
        },
        calendar_visible: function () {
            return this.mode == 'static' ? false : this.hiddenList;
        },
        errorClass: function () {
            return this.errors ? 'n2-invalid-field' : '';
        },
        selectedDateString: {
            get() {
                if (this.value) {
                    let array = this.value.split('-');
                    switch (this.locale) {
                        case 'nb-NO':
                        case "nn-NO":
                        case "no":
                            return array[2] + '.' + array[1] + '.' + array[0];
                        default:
                            return parseInt(array[1]) + '/' + parseInt(array[2]) + '/' + array[0];
                    }

                }
                return '';
            },
            set(val) {
                this.userText = val;
            }
        },

        current_month: function () {
            if (this.view_month) {
                return this.view_month;
            }
            else if (this.initial_month) {
                return `${this.initial_month.substring(0, 7)}-01`;
            }
            else if (this.value) {
                return `${this.value.substring(0, 7)}-01`;
            }
            else {
                let localUTCString = this.getLocalDateIsoString(new Date());
                return `${localUTCString.substring(0, 7)}-01`;
            }
        },
        weekdays: function () {
            switch (this.locale) {
                case 'nb-NO':
                case "nn-NO":
                case "no":
                    return ['ma', 'ti', 'on', 'to', 'fr', 'lø', 'sø'];
                default:
                    return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
            }
        },
        firstWeekDay: function () {
            switch (this.locale) {
                case 'nb-NO':
                case "nn-NO":
                case "no":
                    return 'MONDAY';
                default:
                    return 'SUNDAY';
            }
        },

        days: function () {
            var currentDay = new Date(this.current_month);


            let preDays = currentDay.getUTCDay();
            if (this.firstWeekDay === 'MONDAY') {
                preDays -= 1;
                if (preDays < 0) {
                    preDays = 6;
                }
            }
            currentDay = new Date(currentDay.getTime() - preDays * 1000 * 60 * 60 * 24);
            let list = [];
            let timeNow = this.getLocalDateIsoString(new Date());
            for (let i = 0; i < 42; i++) {
                let isToday = false;
                let isSelected = false;
                if (currentDay.toISOString().substring(0, 10) == timeNow) {
                    isToday = true;
                }
                let currentISODate = currentDay.toISOString().split('T')[0];
                if (this.value == currentISODate) {
                    isSelected = true;
                }


                //css
                let csslist = [];
                if (isSelected) {
                    csslist.push('selected');
                }
                if (isToday) {
                    csslist.push('today');
                }

                if (currentDay.getUTCDay() == 0 && this.sunday_css) {
                    csslist.push(this.sunday_css)
                }

                if (currentDay.getUTCDay() == 6 && this.saturday_css) {
                    csslist.push(this.saturday_css)
                }
                if (this.dates_css) {
                    this.dates_css.forEach(dc => {
                        if (dc.date == currentISODate) {
                            csslist.push(dc.css)
                        }
                    })
                }

                if (this.before_date_show) {
                    let dayData = this.before_date_show(currentISODate);
                    if (dayData) {
                        if (dayData.css_class) {
                            csslist = [...csslist, ...dayData.css_class.split(' ')];
                        }
                    }
                }

                //last css
                let valid = this.validateDate(currentISODate);
                if (valid) {
                    if (!csslist.includes('valid-date')) {
                        csslist.push('valid-date');
                    }
                }
                else {
                    if (!csslist.includes('invalid-date')) {
                        csslist.push('invalid-date');
                    }
                }
                if (this.selected_dates) {
                    let selected = this.selected_dates.includes(currentISODate);
                    if (selected) {
                        if (!csslist.includes('selected-date')) {
                            csslist.push('selected-date');
                        }
                    }
                }
                ////////////////////////////////
                list.push({
                    date: currentDay.toISOString().split('T')[0],
                    data: {
                        valid: valid
                    },
                    css_class_list: csslist
                });
                currentDay = new Date(currentDay.getTime() + 1000 * 60 * 60 * 24);
            }
            return list;
        }

    },
    watch: {
        value: function (val) {
            if (val) {
                if (!this.validateDate(val)) {
                    this.$emit('input', '');
                    this.$emit('selected', '');
                }
                else {
                    this.userText = this.selectedDateString;
                }
            }
        },
        min_date: function (val) {
            if (val) {
                let dateNow = new Date();
                let current_month = new Date(dateNow.toISOString().substring(0, 8) + '01');
                let minDay = new Date(val);
                let minMonth = new Date(minDay.toISOString().substring(0, 8) + '01');
                if (minMonth > current_month) {
                    this.view_month = minMonth.toISOString().split('T')[0];
                }
                else {
                    if (!this.value) {
                        this.view_month = current_month.toISOString().split('T')[0];
                    }
                }
            }
        }
    },
    methods: {
        getLocalDateIsoString: function (date) {
            if (this.time_zone) {
                let dateString = date.toLocaleString(this.locale, { day: '2-digit', hour12: false, timeZone: this.time_zone });
                let monthString = date.toLocaleString(this.locale, { month: '2-digit', hour12: false, timeZone: this.time_zone });
                let yearString = date.toLocaleString(this.locale, { year: 'numeric', hour12: false, timeZone: this.time_zone });
                let result = yearString + '-' + monthString + '-' + dateString;
                result = result.replaceAll('.', '')
                return result;
            }
            else {
                let monthString = date.getMonth() >= 9 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString();
                let dayString = date.getDate() >= 9 ? date.getDate() : '0' + date.getDate();
                let res = date.getFullYear() + '-' + monthString + '-' + dayString;
                return res;
            }
        },
        clickTitle:function(){
            this.$refs.el_text.focus();
            this.onFocus();
        },
        clearText: function () {
            this.value = '';
            this.$emit('input', '');
            this.$emit('selected', '');
        },
        validateDate: function (currentISODate) {
            let valid = true;
            let currentDay = new Date(currentISODate);
            if (this.before_date_show) {
                let dayData = this.before_date_show(currentISODate);
                if (dayData) {
                    if (dayData.valid != undefined) {
                        if (!dayData.valid) {

                            valid = false;
                        }
                    }
                }
            }

            //min max
            if (this.min_date) {
                let minDate = new Date(this.min_date);
                if (currentDay < minDate) {
                    valid = false;
                }
            }
            if (this.max_date) {
                let maxDate = new Date(this.max_date);
                if (currentDay > maxDate) {
                    valid = false;
                }
            }
            if (this.valid_dates && !this.valid_dates.includes(currentISODate)) {
                valid = false;
            }
            return valid;
        },
        navMonth: function (e, mon) {
            let year = +this.current_month.substring(0, 4);
            let month = +this.current_month.substring(5, 7);
            let af = month + mon;
            if (af == 13) {
                year++;
                af = 1;
            }
            if (af == 0) {
                year--;
                af = 12;
            }
            this.view_month = `${year}-${af >= 10 ? af : '0' + af}-01`;
        },
        selectDay: function (day) {
            if (day.data.valid) {
                this.hiddenList = true;
                this.$emit('input', day.date);
                this.$emit('selected', day.date);
            }
        },
        onFocus: function () {
            this.hiddenList = false;
        },
        onFocusout: function () {
            this.hiddenList = true;
            if (!this.parseToIsoDate(this.userText)) {
                this.userText = '';
                this.$emit('input', '');
                this.$emit('selected', '');
            }
        },
        onEnter: function () {
        },
        move: function () {
        },
        onTextChanged: function ($event) {
            this.userText = $event.target.value;
            let isoDate = this.parseToIsoDate($event.target.value);
            if (isoDate) {
                this.view_month = isoDate;
                this.$emit('input', isoDate);
                this.$emit('selected', isoDate);
            }
        },
        parseToIsoDate: function (text) {
            let isoDate = '';
            try {
                switch (this.locale) {
                    case 'nb-NO':
                    case "nn-NO":
                    case "no":
                        if (text.length == 10) {
                            let noArroay = text.split('.');
                            if (noArroay.length == 3 && noArroay[2].length == 4) {
                                isoDate = text.split('.').reverse().join('-');
                            }
                        }
                        break;
                    default:
                        if (text.length >= 8 && text.length <= 10) {
                            let dArroay = text.split('/');
                            if (dArroay.length == 3 && dArroay[2].length == 4) {
                                isoDate = parseInt(dArroay[2])
                                    + '-' + (parseInt(dArroay[0]) < 10 ? '0' + parseInt(dArroay[0]) : parseInt(dArroay[0]))
                                    + '-' + (parseInt(dArroay[1]) < 10 ? '0' + parseInt(dArroay[1]) : parseInt(dArroay[1]));
                            }
                        }
                }
                if (isoDate) {
                    return isoDate;
                }
            }
            catch (e) {
                console.log(e)
            }
            return '';
        }
    }
}
</script>
<style lang="sass">
</style>
